export interface ActiveUserCredentials {
    tenantStatus:boolean;
    id: string;
    tenantName: string;
    email: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
    
  }


  
  export const ActiveUser: ActiveUserCredentials = {
    id: "",
    email: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
    tenantStatus: false,
    tenantName: ""
  };
  